<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="initTaskStuData()"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">我的任务&gt;</div>
      </div>
      <div class="body_content">
        <table class="table task_tab">
          <tbody>
          <tr v-for="(task, index) in tasksList" :key="index">
            <td style="width: 0%;"><div class="noRead_tip" :class="{tip_need: task.status == 0}"></div></td>
            <td class="tabTd_content_ellipsis tabTd_content_one" :title="task.content">
              {{task.content}}
              <span>提交截止日期：{{task.submitTime}}</span>
            </td>
            <td class="tabTd_content_ellipsis tabTd_time_one" :title="task.createTime">{{task.createTime}}</td>
            <td class="tabTd_btn_one">
              <button type="button" class="btn btn-default" @click="saveDataIntoStorage()">去查看</button>
              <button type="button" class="btn btn-default" v-if="task.status == 0" @click="ignoreTask(task.id)">忽略</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';

  export default {
    name: "taskStu",
    data() {
      return {
        //任务集合
        tasksList: [],
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initTaskStuData();
      });
    },
    methods: {
      /**
       * 加载初始数据
       */
      initTaskStuData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/findList',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.tasksList = data.list;
          }
        })
      },
      /**
       * 任务忽略
       */
      ignoreTask(id){
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'tasks/edit/'+id,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.initTaskStuData();
          }else{
            "操作失败".showMessage();
          }
        })
      },
      /**
       * 点击查看详情数据跳转路由
       */
      saveDataIntoStorage(){
        let this_ = this;
        //路由跳转
        this_.$router.push({
          name: 'OpenClassMessage',
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/taskStu.css";
</style>



// WEBPACK FOOTER //
// src/components/taskStu.vue